function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */


import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, Input, InputGroup, InputGroupAddon } from 'reactstrap';
import i18n from '@pureartisan/simple-i18n';
import { FaCopy } from 'react-icons/fa';
import copy from 'copy-to-clipboard';
import useStore from './../store';
import TwitterShareBtn from './TwitterShareBtn';
import FacebookShareBtn from './FacebookShareBtn';
import MailShareBtn from './MailShareBtn';
import clsx from 'clsx';

var UnifiedShareModal = function UnifiedShareModal(_ref) {
  var className = _ref.className,
      props = _objectWithoutPropertiesLoose(_ref, ["className"]); // Generic store value setter.


  var setStoreValues = useStore(function (state) {
    return state.setStoreValues;
  });
  var unifiedShareModal = useStore(function (state) {
    return state.unifiedShareModal;
  });

  var toggle = function toggle() {
    setStoreValues({
      unifiedShareModal: !unifiedShareModal
    });
  };

  var defaultRoute = useStore(function (state) {
    return state.defaultRoute;
  });
  var shareHash = useStore(function (state) {
    return state.shareHash;
  });
  var eventShareLink = useStore(function (state) {
    return state.eventShareLink;
  });

  var onCopy = function onCopy() {
    // console.log('oncopy')
    copy(location);
    setStoreValues({
      eventShareLink: eventShareLink + 1
    });
  }; // Update value for share link only when window object exists.


  var _useState = useState(''),
      shareLinkValue = _useState[0],
      setShareLinkValue = _useState[1];

  useEffect(function () {
    setShareLinkValue(!!shareHash ? window.location.origin + window.location.pathname + shareHash : window.location.origin + window.location.pathname + defaultRoute);
  }, [shareHash]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: !!unifiedShareModal,
    toggle: toggle,
    className: clsx(className, 'bs-expl'),
    backdrop: true,
    keyboard: true,
    autoFocus: true,
    centered: true
  }, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: toggle
  }), /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement("h3", null, i18n.translate('MODAL_SHARE_LINK_HEAD')), /*#__PURE__*/React.createElement(TwitterShareBtn, null), /*#__PURE__*/React.createElement(FacebookShareBtn, null), /*#__PURE__*/React.createElement(MailShareBtn, null), /*#__PURE__*/React.createElement("div", {
    className: clsx('input-group-parent')
  }, /*#__PURE__*/React.createElement("p", null, i18n.translate('MODAL_SHARE_LINK_INSTR')), /*#__PURE__*/React.createElement("label", {
    id: "share_input_label"
  }, i18n.translate('MODAL_SHARE_LINK_INPUT')), /*#__PURE__*/React.createElement(InputGroup, null, /*#__PURE__*/React.createElement(Input, {
    value: shareLinkValue,
    readOnly: true,
    "aria-labelledby": 'share_input_label'
  }), /*#__PURE__*/React.createElement(InputGroupAddon, {
    addonType: "append"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    onClick: onCopy
  }, /*#__PURE__*/React.createElement(FaCopy, null))))))));
};

export default UnifiedShareModal;